var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncomeVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 56,
    viewBox: "0 0 196 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.784 21.5333V11.698C177.784 9.50132 176.911 7.39465 175.358 5.84139C173.805 4.28814 171.698 3.41553 169.501 3.41553C167.305 3.41553 165.198 4.28814 163.645 5.84139C162.091 7.39465 161.219 9.50132 161.219 11.698V21.5333",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.094 21.5305H157.907C155.163 21.5305 152.938 23.7551 152.938 26.4993V44.718C152.938 47.4622 155.163 49.6868 157.907 49.6868H181.094C183.838 49.6868 186.063 47.4622 186.063 44.718V26.4993C186.063 23.7551 183.838 21.5305 181.094 21.5305Z",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 33.0088,
    r: 3.25439,
    fill: "#D8D7E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.292 34.9242C167.538 34.0656 168.322 33.4736 169.215 33.4736H169.785C170.677 33.4736 171.462 34.0656 171.708 34.9242L172.956 39.2926C173.321 40.5702 172.361 41.8421 171.033 41.8421H167.967C166.638 41.8421 165.679 40.5702 166.044 39.2926L167.292 34.9242Z",
    fill: "#D8D7E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8743 17.0022H8.12427C5.43188 17.0022 3.24927 19.1848 3.24927 21.8772V44.6272C3.24927 47.3196 5.43188 49.5022 8.12427 49.5022H43.8743C46.5667 49.5022 48.7493 47.3196 48.7493 44.6272V21.8772C48.7493 19.1848 46.5667 17.0022 43.8743 17.0022Z",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6262 17.0015V13.7515C14.6262 12.8895 14.9686 12.0629 15.5781 11.4534C16.1876 10.8439 17.0142 10.5015 17.8762 10.5015H34.1262C34.9881 10.5015 35.8148 10.8439 36.4243 11.4534C37.0337 12.0629 37.3762 12.8895 37.3762 13.7515V17.0015",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7493 28.3757H3.24927",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5004 28.3757V30.8136C32.5004 31.0291 32.4148 31.2358 32.2624 31.3882C32.11 31.5406 31.9033 31.6262 31.6878 31.6262H20.3112C20.0957 31.6262 19.889 31.5406 19.7366 31.3882C19.5842 31.2358 19.4986 31.0291 19.4986 30.8136V28.3757",
    stroke: "#D8D7E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 33,
    width: 79,
    height: 2,
    rx: 1,
    fill: "url(#paint0_linear_3298_3666)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3298_3666",
    x1: 60,
    y1: 33,
    x2: 145,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6841BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1BAFA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeVerification);
export default __webpack_public_path__ + "static/media/income-verification.07d8ddd6.svg";
export { ForwardRef as ReactComponent };